module.exports = __webpack_public_path__ + "static/img/SL.a48fc7d0.svg";